<script setup lang="ts">
interface Props {
  title: string;
  leadingLabel?: string;
  trailingLabel?: string;
}

defineProps<Props>();
const emit = defineEmits<{ menu: []; profile: [] }>();
</script>

<template>
  <div data-testid="nav-panel" class="w-full max-w-nav-panel mx-auto px-lg py-md bg-bg-card/92 rounded-medium shadow-nav-panel">
    <div class="flex items-center justify-between">
      <button
        type="button"
        class="w-10 h-10 flex items-center justify-center rounded-small text-text-primary outline-none focus-visible:ring-2 focus-visible:ring-brand-300 focus-visible:ring-offset-2 focus-visible:ring-offset-bg-card transition-colors duration-fast hover:bg-grey-200 active:bg-grey-300"
        :aria-label="leadingLabel ?? 'Menu'"
        @click="emit('menu')"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </button>
      <span class="text-title-medium font-medium text-text-primary">{{ title }}</span>
      <button
        type="button"
        class="w-10 h-10 flex items-center justify-center rounded-small text-text-primary outline-none focus-visible:ring-2 focus-visible:ring-brand-300 focus-visible:ring-offset-2 focus-visible:ring-offset-bg-card transition-colors duration-fast hover:bg-grey-200 active:bg-grey-300"
        :aria-label="trailingLabel ?? 'Profil'"
        @click="emit('profile')"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      </button>
    </div>
  </div>
</template>
